/**
 * 店铺图标
 */
const StoreIcon = ({ width = 20, height = 20 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.16699 11.668V17.5013H15.8337V11.668"
        stroke="black"
        strokeWidth="1.66667"
        strokeLinecap="square"
      />
      <path
        d="M4.06418 3.33464H3.45919L3.27182 3.90988L2.60732 5.95L2.60434 5.95914L2.60158 5.96835C2.56783 6.08069 2.54234 6.19532 2.52535 6.31141L2.52308 6.32692L2.52139 6.34251L2.50895 6.45763L2.50583 6.48643L2.50473 6.51538L2.50028 6.63176L2.4997 6.64702L2.49968 6.6623C2.49868 7.31217 2.7608 7.92818 3.21672 8.38843L3.80876 7.80197L3.21672 8.38843C3.67115 8.84717 4.28403 9.11836 4.92807 9.16164C5.57197 9.20491 6.2159 9.01842 6.73038 8.62887C7.10191 8.34757 7.38806 7.97321 7.55551 7.54598C7.69958 7.91359 7.93212 8.24373 8.23372 8.50906C8.70338 8.92225 9.30938 9.15219 9.93474 9.16718C10.5601 9.18218 11.1765 8.98163 11.6664 8.5928C12.0166 8.3148 12.2863 7.95255 12.4463 7.54205C12.4927 7.65957 12.5484 7.77362 12.6127 7.88322C12.7891 8.18362 13.0268 8.44316 13.3085 8.64813C13.59 8.853 13.9102 8.99968 14.2489 9.08158C14.5876 9.16347 14.9397 9.17942 15.2845 9.12878C15.6293 9.07813 15.9617 8.96159 16.2614 8.78422L15.8369 8.0671L16.2614 8.78422C16.5611 8.6068 16.8229 8.37148 17.0283 8.09018C17.2337 7.80872 17.3779 7.48767 17.4491 7.14624C17.5203 6.80469 17.5163 6.4527 17.4375 6.11284L17.4348 6.10115L17.4317 6.08954L17.4095 6.00487L17.404 5.98403L17.3975 5.9635L16.745 3.91505L16.5601 3.33464H15.951H4.06418Z"
        stroke="black"
        strokeWidth="1.66667"
      />
    </svg>
  )
}

export default StoreIcon
